document.addEventListener("DOMContentLoaded", () => {
    Livewire.hook('message.sent', (message, component) => {
        if (component.el.closest('#account-order-offers')) {
            return;
        }

        const exceptions = [
            'disable-spinner',
            'all-filters',
            'loan-right-now',
            'filter-button',
            'loan-filter',
            'loan-verify-modal',
            'account-order-offers',
            'cookie-consent-banner'
        ];

        if (exceptions.includes(component.el.id) === false) {
            document.getElementById('spinnerLoad').style.display = 'flex';
        }

    });

    Livewire.hook('message.processed', (message, component) => {
        if (component.el.closest('#account-order-offers')) {
            return;
        }

        const exceptions = [
            'disable-spinner',
            'all-filters',
            'loan-right-now',
            'filter-button',
            'loan-filter',
            'loan-verify-modal',
            'account-order-offers',
            'cookie-consent-banner'
        ];

        if (exceptions.includes(component.el.id) === false) {
            document.getElementById('spinnerLoad').style.display = 'none';
        }
    });
});
window.addEventListener('spinnerLoadEnd', event => {
    document.getElementById('spinnerLoad').style.display = 'none';
})
